// PDF to image (FR-15): which pages, and how big each picture gets.
import { MAX_PIXELS } from "@/lib/image/size";
import { parseRanges } from "@/lib/pdf/ranges";

export const DPI_CHOICES = [72, 150, 300] as const;
export type Dpi = (typeof DPI_CHOICES)[number];

/** PDF sizes are in points (1/72 inch). */
export const POINTS_PER_INCH = 72;

/** 0-based pages to export: every page, or the ones in a range like "1-3, 5". */
export function pagesToExport(
  mode: "all" | "range",
  text: string,
  pageCount: number,
): { pages: number[] } | { error: string } {
  if (mode === "all") {
    return { pages: Array.from({ length: pageCount }, (_, i) => i) };
  }
  const parsed = parseRanges(text, pageCount);
  if ("error" in parsed) return parsed;
  // Keep the typed order but drop repeats.
  return { pages: [...new Set(parsed.groups.flat())] };
}

/** Scale for pdf.js (1 = 72 DPI), lowered if the picture would pass the
 *  16-megapixel limit phones can draw. */
export function renderScale(
  page: { width: number; height: number },
  dpi: number,
): { scale: number; width: number; height: number; reduced: boolean } {
  let scale = dpi / POINTS_PER_INCH;
  let width = Math.round(page.width * scale);
  let height = Math.round(page.height * scale);
  const reduced = width * height > MAX_PIXELS;
  if (reduced) {
    scale *= Math.sqrt(MAX_PIXELS / (width * height));
    width = Math.round(page.width * scale);
    height = Math.round(page.height * scale);
  }
  return { scale, width, height, reduced };
}
